import React from 'react'

import { useAppSelector } from 'redux/hooks'
import { selectCollectionCards } from 'redux/collectionV2/selectors'

import ImageCollectionCard from './ImageCollectionCard'
import CardWrapper from 'components/collectionV2/views/CardWrapper'

import styles from './image.module.scss'

type Layout = 'small' | 'normal' | 'large'

const LAYOUT_CSS: Record<Layout, string> = {
  small: styles.layoutSmall,
  normal: styles.layoutNormal,
  large: styles.layoutLarge,
}

const validateLayout = (layout: string | undefined): Layout => {
  if (layout === 'small' || layout === 'normal' || layout === 'large') return layout

  return 'normal'
}

const ImageView = () => {
  const cardIds = useAppSelector(selectCollectionCards)
  const imageSize = useAppSelector(state => state.collectionV2.imageSize)

  const layout = validateLayout(imageSize)
  const layoutClass = LAYOUT_CSS[layout]

  return (
    <div className={styles.container}>
      <div className={`${styles.grid} ${layoutClass}`}>
        {cardIds.map(collectionCardId => (
          <CardWrapper key={collectionCardId} component={ImageCollectionCard} collectionCardId={collectionCardId} />
        ))}
      </div>
    </div>
  )
}

export default ImageView
